import { render, staticRenderFns } from "./ExportedPastelInvoices.vue?vue&type=template&id=c6b50774"
import script from "./ExportedPastelInvoices.vue?vue&type=script&lang=js"
export * from "./ExportedPastelInvoices.vue?vue&type=script&lang=js"
import style0 from "./ExportedPastelInvoices.vue?vue&type=style&index=0&id=c6b50774&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports